var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13L11.3333 9.66667L10.1667 8.5L8.83333 9.83333V6.33333H7.16667V9.83333L5.83333 8.5L4.66667 9.66667L8 13ZM2.16667 4.66667V13.8333H13.8333V4.66667H2.16667ZM2.16667 15.5C1.70833 15.5 1.3125 15.3403 0.979167 15.0208C0.659722 14.6875 0.5 14.2917 0.5 13.8333V3.4375C0.5 3.24306 0.527778 3.05556 0.583334 2.875C0.652778 2.69444 0.75 2.52778 0.875 2.375L1.91667 1.10417C2.06944 0.909722 2.25694 0.763889 2.47917 0.666666C2.71528 0.555555 2.95833 0.5 3.20833 0.5H12.7917C13.0417 0.5 13.2778 0.555555 13.5 0.666666C13.7361 0.763889 13.9306 0.909722 14.0833 1.10417L15.125 2.375C15.25 2.52778 15.3403 2.69444 15.3958 2.875C15.4653 3.05556 15.5 3.24306 15.5 3.4375V13.8333C15.5 14.2917 15.3333 14.6875 15 15.0208C14.6806 15.3403 14.2917 15.5 13.8333 15.5H2.16667ZM2.5 3H13.5L12.7917 2.16667H3.20833L2.5 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.457cb3e31a516ac7dd5df85c13fd6261.svg";
export { ForwardRef as ReactComponent };